import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <Section id="purchase-section" background="gradient-purple" className="text-center py-20 md:py-32" data-id="element-84">
      <div className="max-w-4xl mx-auto" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-86">
          <h2 className="text-4xl md:text-6xl font-black text-slate-900 mb-6" data-id="element-87">
            No tenés que seguir viviendo así
          </h2>

          <p className="text-xl md:text-2xl text-slate-700 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-88">
            ENERGÍA REAL es una invitación a dejar de sobrevivir la adultez con
            la batería en rojo. <br data-id="element-89" />
            <span className="font-bold text-fuchsia-700" data-id="element-90">
              No para hacer menos. Sino para vivir mejor.
            </span>
          </p>

          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-2xl border-4 border-fuchsia-200 relative overflow-hidden max-w-3xl mx-auto" data-id="element-91">
            <div className="absolute inset-0 bg-gradient-to-r from-fuchsia-50/50 to-pink-50/50" data-id="element-92"></div>

            <div className="relative z-10" data-id="element-93">
              <div className="mb-8" data-id="element-94">
                <div className="flex items-center justify-center gap-4 mb-4" data-id="element-95">
                  <span className="text-slate-400 text-2xl line-through" data-id="element-96">
                    $35.000
                  </span>
                  <span className="bg-gradient-to-r from-rose-500 to-pink-500 text-white px-4 py-1 rounded-full text-sm font-bold shadow-lg" data-id="element-97">
                    -43% HOY
                  </span>
                </div>
                <div className="flex items-center justify-center gap-2" data-id="element-98">
                  <span className="text-6xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-600 to-pink-600" data-id="element-99">
                    $19.999
                  </span>
                  <span className="text-slate-600 text-2xl" data-id="element-100">ARS</span>
                </div>
              </div>

              <Button href="https://checkout.infinita-mente.online/checkouts/cn/hWN8DLQrMRMlUOLBbsQXm56g/es-ar?_r=AQABVUqWxWx-YYE6q4IcunY9hcWfSVp5nwYN6qJAahvLEQc&cart_link_id=qAwPfsYD&preview_theme_id=138558668898" external variant="vibrant" size="xxl" fullWidth className="mb-6 shadow-2xl shadow-fuchsia-500/30 animate-pulse" data-id="element-101">
                👉 Empezar a recuperar energía real hoy (sin exigirme más)
              </Button>

              <p className="text-sm text-slate-600 font-medium flex flex-wrap justify-center gap-4" data-id="element-102">
                <span data-id="element-103">✨ Acceso inmediato</span>
                <span data-id="element-104">✨ Método amable</span>
                <span data-id="element-105">✨ Aplicable a tu vida real</span>
              </p>
            </div>
          </div>

          <div className="mt-8 flex justify-center gap-4 opacity-60 grayscale hover:grayscale-0 transition-all" data-id="element-106">
            <div className="h-8 px-3 bg-white rounded border border-slate-200 flex items-center text-xs font-bold text-slate-600" data-id="element-107">
              VISA
            </div>
            <div className="h-8 px-3 bg-white rounded border border-slate-200 flex items-center text-xs font-bold text-slate-600" data-id="element-108">
              MASTERCARD
            </div>
            <div className="h-8 px-3 bg-white rounded border border-slate-200 flex items-center text-xs font-bold text-slate-600" data-id="element-109">
              MERCADO PAGO
            </div>
          </div>
        </motion.div>
      </div>
    </Section>;
}